module.exports = __webpack_public_path__ + "img/javascript.94ae2dcd.png";